import { UserTypeEnum } from '@/enums/crm/user-type.enum';
import SettingsModel from '@/models/crm/settings.model';
import UserContactInfo from '@/models/crm/user-contact-info.model';

const nenhumAtendente = -1;

export abstract class AttendantFilterHelper {
  static requiresAllowedAttendants(settings: SettingsModel | null): boolean {
    return Boolean(settings?.restringeVisualizacaoPorHierarquia) && !settings?.visualizaTudo;
  }

  static isAttendantFilterAvailable(settings: SettingsModel | null, userContactInfo: UserContactInfo | null): boolean {
    if (settings?.loggedUserType !== UserTypeEnum.Normal) {
      return true;
    }
    return Boolean(settings?.restringeVisualizacaoPorHierarquia)
      && (Boolean(userContactInfo?.usuarioDiretorCRM) || Boolean(userContactInfo?.usuarioGestorCRM));
  }

  /**
   * Com a restrição por hierarquia ligada, filtro vazio significa "todos que eu posso ver": as opções do combo
   * já vêm recortadas pelo servidor, então elas viram o filtro enviado em vez de "sem filtro". Sem opções
   * conhecidas, envia um id que não casa com ninguém, porque o servidor lê lista vazia como "sem filtro".
   */
  static resolveAttendantIds(
    settings: SettingsModel | null,
    selectedIds: number[] | null | undefined,
    allowedOptions: { id: number }[],
  ): number[] | null {
    if (selectedIds?.length) {
      return selectedIds;
    }
    if (AttendantFilterHelper.requiresAllowedAttendants(settings)) {
      return allowedOptions.length ? allowedOptions.map((option) => option.id) : [nenhumAtendente];
    }
    return null;
  }
}
